const REFERRERS = [
    // クラブごとに下記ドメインからの遷移可能性があり。
    // （福利厚生倶楽部）
    'https://www.fukuri.jp',
    'https://sp.fukuri.jp',
    // （クラブオフアライアンス）
    'https://www.club-off.com',
    'https://sp.club-off.com',
    'https://www.gaku-wari.com',
    'https://sp.gaku-wari.com',
    'https://www.fromnow.jp',
    'https://sp.fromnow.jp',
    'http://www.offtime-members.com',
    'http://sp.offtime-members.com',
];
export class ReloclubService {
    constructor(localStorage) {
        Object.defineProperty(this, "localStorage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "saveKidIfShould", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (kid) => {
                const referrer = document.referrer; // その時々のリファラが欲しいのでローカルストレージからは取得しない
                if (!referrer)
                    return;
                const domain = new URL(referrer).origin;
                if (!REFERRERS.includes(domain))
                    return;
                this.localStorage.saveReloclubKid(kid);
            }
        });
        this.localStorage = localStorage;
    }
}
